<div>
  <input
    #amountTypeInput="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="ag-text-field-input"
    type="text"
    [(ngModel)]="currentValue"
    (click)="openMenu()"
    [ngClass]="currentValue ? 'input-background-active' : ''" />
    @if (!currentValue) {
      <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
    }
    @if (currentValue) {
      <span class="sdps-text-secondary delete-icon-padding" (click)="clearAmountType($event)"
        ><img class="deleteIcon" [src]="deleteIcon"
      /></span>
    }
    <ng-template
      cdkConnectedOverlay
      (overlayOutsideClick)="toggleAmountType(false)"
      (overlayKeydown)="toggleAmountType(false)"
      [cdkConnectedOverlayOrigin]="amountTypeInput"
      [cdkConnectedOverlayOpen]="isOpen">
      <div class="container">
        <div class="radio-btns">
          <ul>
            @for (amountType of amountTypeOptions; track amountType) {
              <div class="amountType-item">
                <input type="radio" [id]="amountType" name="amountType" [(ngModel)]="selectedValue" [value]="amountType" />
                <label [for]="amountType" [innerText]="amountType"></label>
              </div>
            }
          </ul>
        </div>
        <div class="filter-actions">
          <button type="button" class="btn btn-success" (click)="applyAmountType()">Apply</button>
          <a href="#" (click)="clearAmountType($event)"> Clear </a>
        </div>
      </div>
    </ng-template>
  </div>
